var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 9,
    viewBox: "0 0 18 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99953 8.80014C8.29953 8.80014 7.59953 8.53014 7.06953 8.00014L0.549531 1.48014C0.259531 1.19014 0.259531 0.710137 0.549531 0.420137C0.839531 0.130137 1.31953 0.130137 1.60953 0.420137L8.12953 6.94014C8.60953 7.42014 9.38953 7.42014 9.86953 6.94014L16.3895 0.420137C16.6795 0.130137 17.1595 0.130137 17.4495 0.420137C17.7395 0.710137 17.7395 1.19014 17.4495 1.48014L10.9295 8.00014C10.3995 8.53014 9.69953 8.80014 8.99953 8.80014Z",
    fill: "#455CC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownTwo);
export default __webpack_public_path__ + "static/media/ArrowDownTwo.772e6357.svg";
export { ForwardRef as ReactComponent };